import React from 'react';

export interface FormFieldProps {
  label?: string;
  required?: boolean;
  error?: string | null;
  helperText?: string;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}

export function FormField({
  label,
  required = false,
  error,
  helperText,
  htmlFor,
  className = '',
  children,
}: FormFieldProps) {
  return (
    <div className={`flex flex-col space-y-1.5 ${className}`}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="text-xs sm:text-sm font-medium text-gray-700 flex items-center select-none"
        >
          <span>{label}</span>
          {required && (
            <span
              className="text-red-500 font-bold ml-1"
              title="Campo obrigatório"
              aria-hidden="true"
            >
              *
            </span>
          )}
        </label>
      )}
      {children}
      {error && (
        <p className="text-xs text-red-600 mt-0.5 font-medium flex items-center gap-1" role="alert">
          {error}
        </p>
      )}
      {helperText && !error && (
        <p className="text-xs text-gray-500 mt-0.5">{helperText}</p>
      )}
    </div>
  );
}

export default FormField;
